import script from "./DocumentosGestaoPage.vue?vue&type=script&setup=true&lang=js"
export * from "./DocumentosGestaoPage.vue?vue&type=script&setup=true&lang=js"

import "./DocumentosGestaoPage.vue?vue&type=style&index=0&id=073aae89&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-073aae89"]])

export default __exports__